/** Operator-facing labels for superseded Playback MP3 cleanup state. */
export function playbackObjectRemovalDisplay(artifact: {
  status?: string;
  playbackObjectRemoved?: boolean | null;
  playbackObjectRemovalStatus?: string | null;
  playbackObjectRemovedAt?: string | null;
  playbackObjectRemoveError?: string | null;
}): { code: string; label: string; attention: boolean } | null {
  if (!artifact) return null;
  const status = artifact.playbackObjectRemovalStatus;
  if (artifact.playbackObjectRemoved === true || status === "removed") {
    return { code: "removed", label: "Removed", attention: false };
  }
  if (status === "failed") {
    return {
      code: "failed",
      label: "Cleanup failed — attention required",
      attention: true,
    };
  }
  if (status === "pending_retry") {
    return { code: "pending_retry", label: "Cleanup pending", attention: true };
  }
  if (artifact.status === "superseded" || artifact.status === "revoked") {
    return {
      code: "legacy_untracked",
      label: "Not tracked (pre-cleanup policy)",
      attention: false,
    };
  }
  return null;
}
